const getPageUrl = (location = window.location) =>
	removeTrailingSlash(location.pathname);

const removeTrailingSlash = str => (str.endsWith('/') ? str.slice(0, -1) : str);

export { getPageUrl }; // eslint-disable-line
